import {
  ApplicationRef,
  ComponentFactoryResolver,
  ComponentRef,
  Injectable,
  Injector,
  ViewContainerRef,
  Type,
  StaticProvider
} from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable()
export class ComponentsHelperService {
  public root: ViewContainerRef;
  protected applicationRef: ApplicationRef;
  protected componentFactoryResolver: ComponentFactoryResolver;
  protected injector: Injector;

  public constructor(
    applicationRef: ApplicationRef,
    componentFactoryResolver: ComponentFactoryResolver,
    injector: Injector
  ) {
    console.warn(
      'ComponentsHelperService is DEPRECATED, please check ComponentLoader and tooltips as a sample'
    );
    this.applicationRef = applicationRef;
    this.componentFactoryResolver = componentFactoryResolver;
    this.injector = injector;
  }

  public getDocument(): any {
    return this.injector.get(DOCUMENT);
  }

  public setRootViewContainerRef(value: ViewContainerRef): void {
    console.warn(
      'This hack is not needed any more, please remove any usage of ComponentsHelperService'
    );
    this.root = value;
  }

  public getRootViewContainerRef(): ViewContainerRef {
    // https://github.com/angular/angular/issues/9293
    if (this.root) {
      return this.root;
    }

    const comps = this.applicationRef.components;

    if (!comps.length) {
      throw new Error('ApplicationRef instance not found');
    }

    try {
      /* one more ugly hack, read issue above for details */
      const rootComponent = (this.applicationRef as any)._rootComponents[0];
      this.root = rootComponent._hostElement.vcRef;
      return this.root;
    } catch (e) {
      throw new Error('ApplicationRef instance not found');
    }
  }

  public appendNextToLocation<T>(
    ComponentClass: Type<T>,
    location: ViewContainerRef,
    providers?: StaticProvider[]
  ): ComponentRef<T> {
    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(
      ComponentClass
    );
    const parentInjector = location.parentInjector;
    let childInjector: Injector = parentInjector;
    if (providers && providers.length > 0) {
      childInjector = Injector.create({
        providers: providers,
        parent: parentInjector
      });
    }

    return location.createComponent(
      componentFactory,
      location.length,
      childInjector
    );
  }

  public appendNextToRoot<T>(
    ComponentClass: Type<T>,
    ComponentOptionsClass: any,
    options: any
  ): ComponentRef<T> {
    const location = this.getRootViewContainerRef();
    const providers = [{ provide: ComponentOptionsClass, useValue: options }];
    return this.appendNextToLocation(ComponentClass, location, providers);
  }
}
